<template>
  <el-container class="navigator" direction="vertical" >
    <el-header class="header" height="50px">
      <div class="header-logo">
        <h1 class="header-logo-inner">Unidata DMS</h1>
      </div>
      <header-user-info></header-user-info>
    </el-header>

    <el-container class="body" direction="horizontal">
      <!--<div class="body-edgeLine" @mousedown="move"></div>-->
      <el-main class="body-main" style="min-width: 900px;">
        <div
          class="body-main-container"
          style="position: relative; overflow-x: hidden">
          <slot></slot>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import HeaderUserInfo from '../layouts/HeaderUserInfo';

export default {
  name: 'NavigatorHome',

  components: {
    HeaderUserInfo
  }
};
</script>

<style scoped lang="scss">
// 侧边栏宽度
$width-aside: 240px;
$height-header: 50px;

.navigator {
  height: 100vh;
  overflow: hidden;

  .header {
    height: $height-header !important;
    background-color: #272a33;
    padding-left: 20px;
    padding-right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-logo {
      &-inner {
        margin: 0;
        padding: 0;
        color: #fff;
        font-weight: normal;
        font-size: 18px;
      }
    }
  }

  .body {
    min-height: 0;
    position: relative;

    &-aside {
      width: $width-aside;

      &-menu {
        height: 100%;

        &::v-deep .el-menu-item.is-active {
          background-color: #00a0ff !important;
        }
      }
    }

    &-main {
      background-color: #eff3fb;
      padding: 8px;
      overflow: hidden;

      &-container {
        background-color: #fff;
        height: 100%;
        overflow-y: auto;
      }
    }
  }
}
</style>

<style lang="scss">
.popover_content_of_navigator {
  width: 100%;

  .wrapper {
    padding-left: 18px;
    padding-right: 18px;
    height: 48px;
    line-height: 48px;
    font-size: 13px;
    color: #eaeaea;
    background-color: #36313a;
  }

  .username {
    background-color: #232026;
  }

  .logout {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4875f6;
    border-top: 1px solid #232026;
    cursor: pointer;
  }
}

.popper_styles_of_navigator {
  background-color: #36313a;
  padding: 0 !important;
}
</style>
